import {Space, Steps} from "antd";
import {useCreateProductContext} from "../../context/create-product";
import {CreateProductSteps} from "../../reducers/create-product/types";

export function CreateProductFormSteps() {
  const {state} = useCreateProductContext();
  const mapStepToNumber: Record<CreateProductSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    contentUpload: 2,
    variantForm: 3,
    automations: 4,
    checkoutForm: 5,
  };

  return (
    <div>
      <Steps
        current={mapStepToNumber[state.currentCreateProductStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Product information" />
        <Steps.Step
          title="Cover image upload"
          disabled={state.currentCreateProductStep === "basicForm"}
        />
        <Steps.Step
          title="Content upload"
          disabled={
            state.currentCreateProductStep === "basicForm" ||
            state.currentCreateProductStep === "coverImagesUpload"
          }
        />

        <Steps.Step
          title="Add-ons"
          disabled={
            state.currentCreateProductStep === "basicForm" ||
            state.currentCreateProductStep === "coverImagesUpload" ||
            state.currentCreateProductStep === "contentUpload"
          }
        />

        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateProductStep === "basicForm" ||
            state.currentCreateProductStep === "coverImagesUpload" ||
            state.currentCreateProductStep === "contentUpload" ||
            state.currentCreateProductStep === "variantForm"
          }
        />

        <Steps.Step
          title="Checkout form"
          disabled={
            state.currentCreateProductStep === "basicForm" ||
            state.currentCreateProductStep === "variantForm" ||
            state.currentCreateProductStep === "coverImagesUpload" ||
            state.currentCreateProductStep === "contentUpload" ||
            state.currentCreateProductStep === "automations"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateProductFormStepsMobile() {
  const {state} = useCreateProductContext();
  const mapStepToNumber: Record<CreateProductSteps, number> = {
    basicForm: 0,
    coverImagesUpload: 1,
    contentUpload: 2,
    variantForm: 3,
    automations: 4,
    checkoutForm: 5,
  };
  const mapStepToTitle: Record<CreateProductSteps, string> = {
    basicForm: "Product information",
    checkoutForm: "Checkout form",
    coverImagesUpload: "Cover image upload",
    contentUpload: "Content upload",
    variantForm: "Add-ons",
    automations: "Automations",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateProductStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateProductStep]}</p>
    </Space>
  );
}
